var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import cs from '../_util/classNames';
import IconDown from '../../icon/react-icon/IconDown';
import { renderElem, isChildrenSelected } from './util';
var SubMenuInline = /** @class */ (function (_super) {
    __extends(SubMenuInline, _super);
    function SubMenuInline(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickSubMenu = function () {
            var _a = _this.props, _key = _a._key, onClickSubMenu = _a.onClickSubMenu, level = _a.level;
            onClickSubMenu && onClickSubMenu(_key, level);
        };
        // 如果当前子菜单没被打开
        if (props.openKeys.indexOf(props._key) < 0) {
            _this.state = {
                height: 0,
            };
        }
        else {
            _this.state = {
                height: 'auto',
            };
        }
        return _this;
    }
    SubMenuInline.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, _key = _b._key, title = _b.title, children = _b.children, openKeys = _b.openKeys, prefixCls = _b.prefixCls, style = _b.style, mode = _b.mode, level = _b.level, _c = _b.selectedKeys, selectedKeys = _c === void 0 ? [] : _c, className = _b.className, rest = __rest(_b, ["_key", "title", "children", "openKeys", "prefixCls", "style", "mode", "level", "selectedKeys", "className"]);
        var submenuOpen = ~openKeys.indexOf(_key);
        var height = this.state.height;
        var baseClassName = prefixCls + "-inline";
        var wrapperClassNames = cs(baseClassName, className);
        // 多级标题头
        var headerClassName = cs(baseClassName + "-header", (_a = {},
            _a[baseClassName + "-header-selected"] = isChildrenSelected(this.props.children, selectedKeys),
            _a));
        // 多级标题内容
        var contentClassName = cs(baseClassName + "-content");
        // 根据level偏移
        var paddingStyle = {
            paddingLeft: (level - 1) * 24,
            display: 'block',
        };
        var currentLevel = level + 1;
        return (React.createElement("div", { className: wrapperClassNames, style: style },
            React.createElement("div", { className: headerClassName, onClick: this.onClickSubMenu },
                React.createElement("span", { style: __assign({}, paddingStyle) }, title),
                React.createElement("span", { className: prefixCls + "-icon-suffix " + (submenuOpen ? 'is-open' : '') },
                    React.createElement(IconDown, null))),
            React.createElement(CSSTransition, { in: !!submenuOpen, timeout: 200, classNames: "h", unmountOnExit: false, onEnter: function (element) {
                    _this.setState({
                        height: 0,
                    }, function () {
                        _this.setState({
                            height: element.scrollHeight,
                        });
                    });
                }, onEntered: function () {
                    _this.setState({
                        height: 'auto',
                    });
                }, onExit: function (element) {
                    _this.setState({
                        height: element.scrollHeight,
                    }, function () {
                        _this.setState({
                            height: 0,
                        });
                    });
                }, onExited: function () {
                    _this.setState({
                    // hide: true,
                    });
                } },
                React.createElement("div", { className: contentClassName, style: { height: height } }, React.Children.map(children, function (child) {
                    return renderElem(child, __assign(__assign({}, rest), { mode: mode, level: currentLevel, prefixCls: prefixCls,
                        openKeys: openKeys,
                        selectedKeys: selectedKeys }));
                })))));
    };
    SubMenuInline.propTypes = {
        style: PropTypes.object,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    };
    SubMenuInline.defaultProps = {
        hide: false,
        height: 'auto',
    };
    return SubMenuInline;
}(Component));
export default SubMenuInline;
